<template>
  <div>
    <img class="background-img col-12 cover h100" src="../assets/space.jpg">

    <div class="flex col-12 justify-between">
      <img class="cbx-logo" src="../assets/CQL_logo_kombi.svg">

    </div>

    <div class="login-window ui-modal--settings box-shadow-big mx-auto bg-color-darkgray rounded-border">
      <div class="pt3 pr3 pl3 pb3">
        <div class="flex align-middle mb2">
          <img class="cbx-logo mr2" style="width: 100px; height:100px;" src="../assets/cql_logo.svg">
          <div>
            <h2 class="h1 white regular">{{$t('login_h_willkommen_cql')}}</h2>
          </div>
        </div>
        <div class="flex flex-wrap col-12 pt2">
          <input v-bind:class="{inputerror : usernameerror}" class="col-4 user-input user-input-narrow   mr1 bg-color-verylightgray" v-model="logindata.email" @change="old_cql_user = false" :placeholder="$t('login_email_placeholder')">
          <input type="password" v-bind:class="{inputerror : passworderror}" class="col-3 user-input user-input-narrow bg-color-verylightgray  mr1" v-model="logindata.password" :placeholder="$t('login_password_placeholder')">
          <a class="btn btn-small" @click="checkLogin">{{$t('login_p_anmelden')}}</a>
         
          <label v-bind:class="{appear : logerror}" class="color-red col-12 p hidden">{{$t('login_p_login_nicht_erfolgreich')}}</label>
           <label v-bind:class="{appear : old_cql_user}" class="color-red p col-12  hidden">{{$t('login_p_altes_konto')}} <a class="white underline pointer" style="pointer-events: all;"  @click="openRegisterFormOldUser()">{{$t('login_p_registrierung')}}</a> {{$t('login_p_notwendig')}}</label>
   
        </div>
       

        
      </div>

      <div class="divider"></div>
      <div class="bg-color-darkgray pr4 pl4 pt3 pb3 rounded-border-bottom flex">
        <div class="flex align-middle">
          <p class="p-small regular color-gray">{{$t('login_p_noch_nicht_registriert')}}</p>
          <a class="btn btn-small ml3" @click="checkRegister()">{{$t('login_p_registrierung')}}</a>
        </div>
        <div class="flex align-middle ml3">
          <p class="p-small regular color-gray">{{$t('login_p_Passwort_vergessen')}}</p>
          <a class="btn btn-ghost-narrow ml3 self-center" @click="lightboxPw = true">{{$t('login_p_passwort_zuruecksetzen')}}</a>
        </div>
      </div>
    </div>
    <Register v-show="lightboxRegister"></Register>
    <ForgotPw v-show="lightboxPw"></ForgotPw>
  </div> 
</template>

<script>

import { EventBus } from "../event-bus";
import axios from 'axios'
import Register from './Register.vue';
import ForgotPw from './ForgotPw.vue';


export default {
  name: "Login",
  data() {
    return {
      logindata: {
        email: '',
        password: '',
      },
      langs: [
        {value: 'de', label: 'Deutsch'}, 
        {value: 'en', label: 'English (metric)'}, 
      ],
      debug: false,
      passwordCorrect: true,
      usernameCorrect: true,
      lightboxRegister: false,
      lightboxPw: false,
      user_id: 0,
      email: '',
      firstname: '',
      name: '',
      company: '',
      usernameerror: false,
      passworderror: false,
      logerror: false,
      systemname: process.env.VUE_APP_SYSTEMNAME,
      old_cql_user: false,

      missingfields:[]
    };
  },
  created: function () {
    if(process.env.VUE_APP_DEMO_CREDENTIALS_SHOW == 'true') {
      this.logindata.email = process.env.VUE_APP_DEMO_CREDENTIALS_USER;
      this.logindata.password = process.env.VUE_APP_DEMO_CREDENTIALS_PASS;
    }
    EventBus.$on('closeRegister', () => { 
      this.lightboxRegister = false;
    });
    EventBus.$on('closePw', () => { 
      this.lightboxPw = false;
    });
    EventBus.$on('closePwOpenRegister', () => { 
      this.lightboxPw = false;
      this.lightboxRegister = true;
    });
    EventBus.$on('closeRegisterOpenPw', () => { 
      this.lightboxPw = true;
      this.lightboxRegister = false;
    });
    EventBus.$on('missingFieldsLoginRecieveEvent', () => { 
      
      EventBus.$emit('missingFieldsLoginEvent2', {
        "missingfields": this.missingfields
      });
    });
     

  },
  components: {
    'ForgotPw' : ForgotPw,
    'Register' : Register
  },

  methods: {
    checkRegister(){

      if(this.old_cql_user == false){
        this.lightboxRegister = true;
      }
      if(this.old_cql_user == true){
        this.openRegisterFormOldUser()
      }
    },
    openRegisterFormOldUser(){

      EventBus.$emit('register_old_cql_user', {
        'email': this.logindata.email,
      });

      this.lightboxRegister = true;
    },
    checkLogin(){

      this.old_cql_user = false;
      this.logerror = false; 

      let createURL = process.env.VUE_APP_APIENDPOINT + '/sso/check-access-data/cobiax-app2'

      let currentObj = this;

      let logindata = JSON.stringify(this.logindata);

      axios.post(createURL, logindata)
      .then(response => {

        this.user_id = response.data.data.user_id;
        this.email = response.data.data.email;
        this.firstname = response.data.data.firstname;
        this.name = response.data.data.name;
        this.company = response.data.data.company;

        if(response.data.message == "LOGIN_OKAY_BUT_CONTRACT_MISSING") {

          if(response.data.register_status == 'MISSINGFIELDS'){

            EventBus.$emit('loginSuccessful', {
              "userdata": response.data.data,
              "session": response.data.session,
            });

            currentObj.missingfields = response.data.missing_fields;
            this.$router.push({ path:'/' + this.$i18n.locale + '/addinfo'});
            
          }else{
            EventBus.$emit('loginSuccessful', {
              "userdata": response.data.data,
              "session": response.data.session,
            });

            this.usernameerror = false;
            this.passworderror = false;
            this.logerror = false

            this.$router.push({ path:'/' + this.$i18n.locale + '/contractsign'});
          }

        }else if (response.data.message == 'LOGIN_FAILED_OLD_CQL_USER'){
          this.old_cql_user = true;

        }else if(response.data.message == "LOGIN_OKAY_BUT_ROLE_FAILED"){
          
          if(response.data.register_status == 'MISSINGFIELDS'){

            EventBus.$emit('loginSuccessful', {
              "userdata": response.data.data,
              "session": response.data.session,
            });

            currentObj.missingfields = response.data.missing_fields;
            this.$router.push({ path:'/' + this.$i18n.locale + '/addinfo'});
            
          }else{
            EventBus.$emit('loginSuccessful', {
              "userdata": response.data.data,
              "session": response.data.session,
            });

            this.usernameerror = false;
            this.passworderror = false;
            this.logerror = false

            this.$router.push({ path:'/' + this.$i18n.locale + '/contractsign'});
          }


        }else if(response.data.message == "LOGIN_OKAY") {

          EventBus.$emit('loginSuccessful', {
            "userdata": response.data.data,
            "session": response.data.session,
          });

          this.usernameerror = false;
          this.passworderror = false;
          this.logerror = false;

          if(response.data.register_status == 'MISSINGFIELDS'){

            currentObj.missingfields = response.data.missing_fields;
            this.$router.push({ path:'/' + this.$i18n.locale + '/addinfo'});

          } else {

            this.$router.push({ path:'/' + this.$i18n.locale + '/projects'});
          }
        } else {

          if(this.logindata.email == "") {
            this.usernameerror = true;
          } else {
            this.usernameerror = false;
          }
          if(this.logindata.password == "") {
            this.passworderror = true;
          } else {
            this.passworderror = false;
          }
          this.logerror = true;
        }
      })
      .catch(function (error) {
        currentObj.log('catch Function of AJAX-Called... error()');
        currentObj.log(error);
        currentObj.apiResponse = error;
      });

    },

    log: function (obj) {
      if(this.debug) {
        console.log(obj)
      }
    },


  },

};
</script>
<style scoped>
</style>
